export type ManagedAgent = {
  id: number; accountId: string; name: string; phone: string | null;
  clusterLeader?:boolean|number;
  saId: string; localStatus: string; status: string; clusterName: string | null;
  checkedAt: string | null;
  deactivation?: { reason: string | null; changedAt: string } | null;
};
export type ManagedAgentDetail = ManagedAgent & {
  accountStatus: 'active' | 'disabled' | null;
  canDisable: boolean; canEnable: boolean; hasOutstanding: boolean;
  outstanding: {
    phones: { id: number; name: string; status: string; imeis: string[] }[];
    pickups: { id: number; reference: string; status: string }[];
    reallocations: { id: number; status: string }[];
  };
  history: { fromStatus: string; toStatus: string; reason: string | null; actorName: string; changedAt: string }[];
};
export const agentStatusLabel = (status: string) => ({ACTIVE:'Active',DISABLED:'Deactivated',BLOCKED:'Sales access restricted',PENDING_ACTIVATION:'Activation incomplete',UNKNOWN:'Status not confirmed'}[status] ?? 'Status not confirmed');
